import script from "./ScrollUpButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollUpButton.vue?vue&type=script&setup=true&lang=js"

import "./ScrollUpButton.vue?vue&type=style&index=0&id=1c4b5dfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4b5dfd"]])

export default __exports__